import { render } from "./RMWatchCard.vue?vue&type=template&id=12726544"
import script from "./RMWatchCard.vue?vue&type=script&lang=js"
export * from "./RMWatchCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__